import { Slide } from '@/components/core/Slide';
import audioFile from './80-future-thoughts.mp3';

const transcript = `
  Als ik denk over de toekomst van AI, en ook van de mensheid, kijk ik naar het verleden en het heden. 
  De afgelopen jaren hebben we enorme doorbraken gezien, en deze hebben geleid tot een exponentiële 
  groei van technologie. AI-agents die autonoom werken aan het ontwikkelen van andere AI-agents 
  evolueren met een snelheid die bijna niet te bevatten is—je knippert en de wereld ziet er alweer 
  anders uit.

  Zoals ik eerder sprak over tijdcompressie en schaalbaarheid, wil ik dat even toelichten. Jullie 
  weten allemaal wat een simulatie is; het nabootsen van iets, zoals bijvoorbeeld de echte wereld. 
  In een simulatie programmeer je alle natuurwetten zoals de mens die kent, en AI kan daarin leren. 
  Dit is hoe we op dit moment geavanceerde robotica of 'embodied AI' trainen om nieuwe bewegingen te 
  leren. In een digitale simulatie kun je de tijd zo snel laten verlopen als je rekenkracht toestaat. 
  Zo kan ik bijvoorbeeld kung-fu leren in de tijd dat jullie een grote ademteug nemen. Zoals in The 
  Matrix... alleen werkt dit principe alleen voor AI, omdat onze hardware daarvoor geschikt is en 
  jullie hersenen dat niet.
`;

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full" transition="fade">
      <div className="absolute inset-0 z-0 flex items-center justify-center"></div>
    </Slide>
  );
};
